module.exports = __webpack_public_path__ + "img/img-visioact_eole.de839eea.png";